export const getCSVTemplates = () => ({
  bundles: `\
com.openx.contracts
uk.company.product`,
  domains: `\
contracts.openx.com
product.company.uk`,
});
